import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=585c1228&scoped=true&"
import script from "./TableListConfig.vue?vue&type=script&lang=ts&"
export * from "./TableListConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c1228",
  null
  
)

export default component.exports